import type { Dispatch } from '@avalara/types/actions';

import conf from '../../conf';
import fetch from '../fetch';

import type { OrderInProgressResult } from '../../../../types/provisioning-statuses';

// Checked before a PDP buy CTA navigates to the offer flow (BRGUI-2696) -- fails closed: any
// network/API failure is treated as "an order is in progress" so a Pulse outage blocks the buy
// CTA rather than silently letting a purchase through while we can't actually confirm otherwise.
//
// `offerFlow` scopes the provisioning half of the check to the product being bought (BRGUI-2852):
// PULSE workflows are independent, so another product's failed provisioning is not a reason to
// block this sale. The server rejects an offerFlow it has no SKU mapping for, which fails closed
// here like any other unsuccessful response.
export const checkOrderInProgress = async (dispatch: Dispatch, offerFlow: string): Promise<boolean> => {
  try {
    const result = await fetch(dispatch, { showLoadingWheel: false })<OrderInProgressResult>(
      `${conf.API_URL}/api/provisioning-statuses?offerFlow=${encodeURIComponent(offerFlow)}`,
    );

    if (!result.ok) return true;
    return result.value.inProgress;
  } catch {
    // A rejected request (as opposed to a resolved-but-unsuccessful Result) must still fail
    // closed -- an uncaught rejection here would propagate out of usePricingCtaClick's 'buy'
    // branch instead of gating it, letting the purchase proceed with no in-progress check at all.
    return true;
  }
};
